import { SequentialFetchQueue } from './sequential-fetch-queue';
import * as fetch from 'cross-fetch';

const fetchTimeout: number = 20000;
const queueTimeout: number = 120000;

export function internalFetch(url: string, options: RequestInit, callback: (error: Error, response: Response) => void): void {
    const request = new fetch.Request(url, options);
    return fetchQueue.add(request, callback);
}

/**
 * NOTE: The cross-fetch type declarations suggest that either of these import statements should work, but they don't:
 * import { fetch } from 'cross-fetch';
 * import fetch from 'cross-fetch';
 */
const fetchQueue = new SequentialFetchQueue(fetch as unknown as (input: Request) => Promise<Response>, fetchTimeout, queueTimeout);
